export default "__VITE_ASSET__Bpt5Jdrp__"